import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';

// TestFlight builds are NOT in Apple's public iTunes lookup API, so the "latest
// build" has to come from us: scripts/bump-build.mjs writes public/version.json on
// every `npm run ios:*`/`android:*`, and each flavor's web deploy publishes it at
// its own host. VITE_API_URL already differs per flavor (app. vs demo.app), so the
// installed app self-routes to the right file with no extra env var.
//
// One number for both flavors — see the ordering caveat in scripts/bump-build.mjs.
export function useUpdateAvailable() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const check = async () => {
      const { build } = await App.getInfo();
      // ponytail: cache-bust via query param. Prod's S3 sync already sets
      // no-cache on non-asset files; demo goes through nginx+traefik where the
      // headers aren't ours, so don't trust them.
      const res = await fetch(`${import.meta.env.VITE_API_URL}/version.json?t=${Date.now()}`);
      if (!res.ok) return;
      const latest = (await res.json())?.[Capacitor.getPlatform()];
      setAvailable(Number(latest) > Number(build));
    };

    // Swallowed: a failed check must never block the app. Worst case the user
    // isn't told about an update, which is where they already are today.
    void check().catch(() => {});
    const sub = App.addListener('resume', () => void check().catch(() => {}));
    return () => void sub.then((s) => s.remove());
  }, []);

  return available;
}
